module.exports = __webpack_public_path__ + "modules/bbs/img/20.gif";